/* =====================================
   Optimized Header Script – FINAL
===================================== */

(() => {

  /* ------------------------------
     DOM Ready
  ------------------------------ */

  document.addEventListener('DOMContentLoaded', () => {

    /* Sticky header show/hide */
    const stickyHeader = document.getElementById('stickyHeader');
    if (stickyHeader) {
      window.addEventListener('scroll', () => {
        stickyHeader.classList.toggle('show', window.scrollY > 100);
      });
    }

    /* Clone main menu into sticky header ONCE */
    const mainNav = document.querySelector('header .main-nav');
    const stickyNav = document.getElementById('stickyNav');
    if (mainNav && stickyNav) {
      stickyNav.appendChild(mainNav.cloneNode(true));
    }

    /* Mobile menu */
    const body = document.body;
    const mobileMenu = document.getElementById('mobileMenu');
    const overlay = document.getElementById('mobileMenuOverlay');
    const openBtn = document.getElementById('openMobileMenu');
    const closeBtn = document.getElementById('closeMobileMenu');

    function closeMenu() {
      mobileMenu?.classList.remove('active');
      overlay?.classList.remove('active');
      body.classList.remove('no-scroll');
    }

    openBtn?.addEventListener('click', () => {
      mobileMenu.classList.add('active');
      overlay.classList.add('active');
      body.classList.add('no-scroll');
    });

    closeBtn?.addEventListener('click', closeMenu);
    overlay?.addEventListener('click', closeMenu);

    /* Mobile submenus */
    document.querySelectorAll('.submenu-toggle').forEach((toggle) => {
      toggle.addEventListener('click', (e) => {
        e.stopPropagation();
        toggle.classList.toggle('open');
        toggle.nextElementSibling?.classList.toggle('show');
      });
    });

    /* Calendly lazy loader */
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-calendly]');
      if (!btn) return;

      e.preventDefault();
      const url = btn.dataset.calendly;

      if (!window.Calendly) {
        const s = document.createElement('script');
        s.src = 'https://assets.calendly.com/assets/external/widget.js';
        s.onload = () => window.Calendly.initPopupWidget({ url });
        document.body.appendChild(s);
      } else {
        window.Calendly.initPopupWidget({ url });
      }
    });
  });
})(); 